import BannerFooter from "@components/About/BannerFooter";
import Banner from "@components/Banner";
import Breadcrumbs from "@components/Breadcrumbs";
import Footer from "@components/Footer";
import Header from "@components/Header";
import FeaturedImages from "@components/MeetingAndEvents/FeaturedImages";
import Intro from "@components/MeetingAndEvents/Intro";
import PersonalizationAndDetails from "@components/MeetingAndEvents/PersonalizationAndDetails/PersonalizationAndDetails";
import RequestForProposal from "@components/MeetingAndEvents/RequestForProposal";
import { useRouteContext } from "@providers/RouteProvider";
import bannerFooterStyles from "../../components/About/BannerFooter.module.scss";
import { usePageContext } from "@providers/PageProvider";
import helper, { meetingPage } from "@utils/helper";
import _ from "lodash";
const View = () => {
  const { router } = useRouteContext();
  const { pageData, hotel } = usePageContext();
  const banner = helper.formatBanner(pageData);
  const footer = helper.renderDetailsFooter(hotel);
  const bannerFooter: any = meetingPage.formatBannerFooter(pageData);
  return (
    <div className="bg-black" data-scroll-container>
      <Header />
      <Banner
        image={_.get(banner, "image")}
        src="/meeting-events/banner.jpg"
        alt="meeting-events-banner"
        title={_.get(banner, "title")}
      />
      <Breadcrumbs data={router.breadcrumbs("meeting-and-events", {})} />
      <Intro />
      <FeaturedImages />
      <PersonalizationAndDetails />
      <RequestForProposal />
      <BannerFooter
        className={bannerFooterStyles.meetingEventsImage}
        image={bannerFooter}
      />
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
        }}
      />
    </div>
  );
};

export default View;
